/* eslint-disable consistent-return */
import React from 'react';

export const usePreventWindowUnload = (preventDefault, callback) => {
  React.useEffect(() => {
    if (!preventDefault) {
      return;
    }
    const handleBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
      if (callback) {
        callback();
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [callback, preventDefault]);
};
